import React from "react";
import { images } from "../../assets/images";
import { sidebarOptions } from "./sidebarOptions";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

const DashboardSidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const {
    user: { userLabel },
    setCurrentTabSelect
  } = useAuth();

  const onClickHelp = () => {
    navigate("/helpcenter");
  };
  const onClickLogo = () => {
    navigate("/");
  };

  return (
    <div className="sidebar-container">
      <img
        src={images.mainLogo}
        className="dashboard-logo cursor-pointer"
        alt="keventer's logo"
        onClick={onClickLogo}
      />
      <div className="sidebar-options">
        {sidebarOptions.map((item, index) => {
          const isActive =
            item.link === "/" || item.link === "/request"
              ? location.pathname === item.link
              : location.pathname.includes(item.link);

          if (!item.showTo.includes(userLabel)) {
            return null;
          }
          return (
            <Link to={item.link} onClick={() => {setCurrentTabSelect({})}} key={"option-" + index}>
              <div
                className={`sidebar-option ${
                  isActive ? "sidebar-option-active" : ""
                }`}
              >
                <div className="sidebar-option-icon-wrapper">
                  <img src={item.icon} alt="sidebar option icon" />
                </div>
                <div
                  className={`sidebar-option-title font-size-small ${
                    isActive ? "font-family-medium" : ""
                  }`}
                >
                  {item.title}
                </div>
              </div>
            </Link>
          );
        })}
      </div>
      <div className="sidebar-footer">
        <button
          className="help-button font-size-small font-family-medium"
          onClick={onClickHelp}
        >
          Help Center
        </button>
        <div className="font-size-small text-[var(--ultraLightGray)] mt-6">
          &copy; Powered by CorePeelers
        </div>
      </div>
    </div>
  );
};

export default DashboardSidebar;
